import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function useNonCrmObject() {
  const {
    nonCrmObject
  } = usePreviewData();
  return nonCrmObject;
}